type IVideoOptions = {
  title?: string;
  showPreview?: boolean;
  showRelatedVideos?: boolean;
  timeLength?: string;
};

export const IFRAME_URL_MAPPER = {
  youtube: (id: string, options: IVideoOptions) => {
    const queryParams = new URLSearchParams({
      autoplay: options.showPreview === false ? '0' : '1',
      rel: options.showRelatedVideos ? '1' : '0',
      color: 'white',
    });
    return `https://www.youtube.com/embed/${id}?${queryParams.toString()}`;
  },
} as const;

export const getWebPImageUrl = (imageUrl: string): string =>
  (imageUrl && imageUrl.replace('/vi/', '/vi_webp/').replace('.jpg', '.webp')) || imageUrl;
